import { createSelector } from 'reselect';

const getEmailVerification = (state) => state.emailVerification;

const EmailVerificationSelectors = {
  makeEmailVerification: createSelector([getEmailVerification], (emailVerification) => emailVerification),
  makeHasFeedListings: createSelector([getEmailVerification], (emailVerification) => emailVerification.hasFeedListings),
  makeHasPendingEmailVerification: createSelector(
    [getEmailVerification],
    (emailVerification) => emailVerification.hasPendingEmailVerification,
  ),
};

export default EmailVerificationSelectors;
